import { Trash2 } from 'lucide-react';

import { IconTile } from '@/design-system/patterns/IconTile';
import { Button } from '@/design-system/ui/Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/design-system/ui/Dialog';

export type ConfirmOptions = {
  title: string;
  /** O impacto, em números ("3 funções serão removidas, 12 membros desvinculados…"). */
  text: string;
  okLabel: string;
  onOk: () => void;
  /** Segunda ação destrutiva ("Excluir toda a série"). */
  altLabel?: string;
  onAlt?: () => void;
  /** Fechou sem confirmar (Cancelar, Esc ou clique fora). */
  onCancel?: () => void;
};

/** Confirmação de ação destrutiva, com o impacto descrito antes de agir. */
export default function ConfirmDialog({
  options,
  onClose,
}: {
  options: ConfirmOptions | null;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={!!options}
      onOpenChange={(open) => {
        if (open) return;

        options?.onCancel?.();
        onClose();
      }}
    >
      {options ? (
        <DialogContent
          role="alertdialog"
          described
          className="z-[85] w-[min(460px,calc(100vw-24px))] gap-4 p-5.5"
        >
          <div className="flex items-start gap-3">
            <IconTile tone="danger" size="md">
              <Trash2 />
            </IconTile>
            <div>
              <DialogTitle className="text-lead font-bold">{options.title}</DialogTitle>
              <DialogDescription className="mt-1 text-control text-pretty text-ink-muted">
                {options.text}
              </DialogDescription>
            </div>
          </div>
          <div className="flex flex-wrap justify-end gap-2">
            <DialogClose asChild>
              <Button variant="secondary">Cancelar</Button>
            </DialogClose>
            {options.altLabel && options.onAlt ? (
              <Button
                variant="destructive"
                onClick={() => {
                  options.onAlt?.();
                  onClose();
                }}
              >
                {options.altLabel}
              </Button>
            ) : null}
            <Button
              variant="danger"
              onClick={() => {
                options.onOk();
                onClose();
              }}
            >
              {options.okLabel}
            </Button>
          </div>
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
